module.exports = __webpack_public_path__ + "img/shijiuda.461614f8.jpg";